import { Component, EventEmitter, input, Output } from '@angular/core';
import { NewChartBaseComponent } from '../../utils/new-chart-base.component';
import { ChartComponent } from '@ex/module/shared/chart/chart.component';

@Component({
  selector: 'new-chart',
  standalone: false,
  templateUrl: './new-chart.component.html',
  styleUrl: './new-chart.component.scss'
})
export class NewChartComponent extends NewChartBaseComponent {
  readonly classes = input();
  readonly width = input(25);
  readonly height = input(31.25);
  readonly language = input('EN');
  readonly exportPageRows = input(21);
  @Output() exportPageLength: EventEmitter<number> = new EventEmitter();

}
